import * as Conversation from './conversation/RequestConversation.selectors';

import { DOMAIN } from './RequestDetails.constants';
import get from 'lodash/get';

export const conversation = Conversation;

export const getStore = state => get(state, DOMAIN) || {};

export const getActionItems = state => getStore(state).actionItems || [];
export const getActionItemsCreating = state => getStore(state).actionItemsCreating;
export const getActionItemsLoading = state => getStore(state).actionItemsLoading;
export const getAuditEvents = state => getStore(state).auditEvents || [];
export const getAuditEventsLoading = state => getStore(state).auditEventsLoading;
export const getDataStoresLoading = state => getStore(state).dataStoresLoading;
export const getEmailNotificationSent = state => getStore(state).emailNotificationSent;
export const getError = state => getStore(state).error;
export const getHasDataStores = state => getStore(state).hasDataStores;
export const getId = state => getStore(state).customerId;
export const getLoading = state => getStore(state).loading;
export const getStatusError = state => getStore(state).statusError;
export const getStatusUpdating = state => getStore(state).statusUpdating;
export const getSummaries = state => getStore(state).summaries || [];
export const getSummariesLoading = state => getStore(state).summariesLoading;
export const getSummariesPackaging = state => getStore(state).summariesPackaging;
export const getViewedStatus = state => getStore(state).viewedStatus;

export const getAuditEventByType = (state, type) => {
    const auditEvents = getAuditEvents(state) || [];
    return auditEvents.find(event => event.auditEventType === type);
};

export const getReadOnly = (state, requestStatus) => {
    const viewedStatus = getViewedStatus(state);
    return requestStatus !== viewedStatus;
};
